module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/washington-9bd0c57c99f95bd5f8c7089c67657059.jpg";